module.exports = __webpack_public_path__ + "static/bg_nasa-fb77e0b1f5ce9f6f7aed72893cf10222.jpg";